module.exports = __webpack_public_path__ + "3fbb3eedb79636f79cf007ce51620ab8.ttf";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Angular-Bold-Oblique.ttf
// module id = 409
// module chunks = 0